export default __webpack_public_path__ + "static/15-e0b85b94f2451b697acafc0bae8c32cf.png";